<template>
  <div class="flex justify-end gap-4 mt-28">
    <vs-button v-if="useExcel" color="secondary" type="border" @click.stop.prevent="$emit('onClickExcel')">엑셀(FMS) 내려받기</vs-button>
    <vs-button v-if="useCopy" color="secondary" type="border" @click.stop.prevent="$emit('onClickCopy')">복사하기</vs-button>
    <vs-button v-if="useDelete" color="secondary" type="border" @click="$emit('onClickDelete')"> 삭제 </vs-button>
    <vs-button color="secondary" type="border" @click="$emit('onClickMoveList')">목록</vs-button>
    <vs-button v-if="useSave" color="secondary" @click="$emit('onClickSave')">저장</vs-button>
  </div>
</template>

<script>
export default {
  props: {
    useCopy: { type: Boolean, default: false },
    useExcel: { type: Boolean, default: true },
    useDelete: Boolean,
    useSave: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
